module.exports = __webpack_public_path__ + "dist/assets/img/growth.eb35b4f4.svg";